<section class="card">
  <div class="card-body">
    <h2 class="section-heading text-uppercase text-muted small fw-semibold mb-2">Context</h2>
    <dl class="row g-2 mb-0">
      <dt class="col-6 text-uppercase small text-secondary mb-0 fw-bold">Account Name</dt>
      <dd class="col-6 mb-0">
        <span class="fw-semibold text-primary">{{ accountName }}</span>
      </dd>
      <dt class="col-6 text-uppercase small text-secondary mb-0 fw-bold">Partition Name</dt>
      <dd class="col-6 mb-0">
        <span class="fw-semibold text-primary">{{ partitionName }}</span>
      </dd>
      <dt class="col-6 text-uppercase small text-secondary mb-0 fw-bold">Data Partition ID</dt>
      <dd class="col-6 mb-0">
        <span class="fw-semibold text-primary">{{ dataPartitionId }}</span>
      </dd>
    </dl>
    <div class="mt-2">
      <button
        type="button"
        class="btn btn-primary w-100"
        [disabled]="loading"
        (click)="fetchContext()"
      >
        {{ loading ? 'Loading context…' : 'Refresh Context' }}
      </button>
    </div>
    @if (fetchError) {
      <p class="text-danger small mt-2 mb-0">{{ fetchError }}</p>
    }
  </div>
</section>
